<div kendoDialogContainer></div>

<maximizer-sync-configuration
  #configuration
  [class.hidden]="installLoaderVisible() || closeBlocked()"
/>

@if (closeBlocked()) {
  <div
    class="max-ng fixed inset-0 z-50 flex h-screen w-screen items-center justify-center bg-neutral-10 p-8"
  >
    <p class="text-body-1 text-neutral-90 max-w-md text-center">
      {{ 'outlookSync.closeWindow.message' | translate }}
    </p>
  </div>
} @else if (installLoaderVisible()) {
  <div
    class="max-ng fixed inset-0 z-50 flex h-screen w-screen items-center justify-center bg-neutral-10"
  >
    <div class="flex flex-col items-center gap-4">
      <maximizer-loader type="legacy"></maximizer-loader>
      <p class="text-body-1 text-neutral-90 mt-20">
        {{ 'outlookSync.install.loaderMessage' | translate }}
      </p>
    </div>
  </div>
}
